// Number of days after sponsorship end date for field drop eligibility
export const FIELD_DROP_ELIGIBILITY_DAYS = 30;

// Content type identifier for Anniversary feed items (used for exclusion in image/video logic)
export const CONTENT_TYPE_CLB_S_ANNIV = "CLB-S-ANNIV";

// Feed/Station content types and labels for FeedItem.js
export const FEED_TYPE_BIRTHDAY = "BIRTHDAY";
export const FEED_TYPE_ANNIVERSARY = "CLB_SPNSHIP_ANNV";
export const MEDIA_STYLE_IMAGE = "Image";
export const MEDIA_TYPE_IMAGE = "IMAGE";
export const MEDIA_TYPE_VIDEO = "VIDEO";
export const MEDIA_STYLE_BIRTHDAY = "BIRTHDAY";
export const MIME_TYPE_PDF = "application/pdf";
export const MEDIA_STYLE_ANNIVERSARY = "ANNIVERSARY";
export const CONTENT_TYPE_CUP ="CUP";
export const FEED_NAME_CPE ="CHILD_PHOTO_EXPANSION";

export const BEFORE_BIRTHDAY_RANGE = 30;
export const AFTER_BIRTHDAY_RANGE = 30;
